export var TRANSFER_DIALOG_COMPONENT_NAME = 'transfer-dialog';
export var TRANSFER_DIALOG_LAZY_COMPONENT_NAME = 'transfer-dialog-lazy-component';
export var RENAME_DIALOG_COMPONENT_NAME = 'rename-dialog';
export var RENAME_DIALOG_LAZY_COMPONENT_NAME = 'rename-dialog-lazy-component';
export var FEEDBACK_DIALOG_COMPONENT_NAME = 'feedback-dialog';
export var FEEDBACK_DIALOG_LAZY_COMPONENT_NAME = 'feedback-dialog-lazy-component';
export var DUPLICATE_DIALOG_COMPONENT_NAME = 'duplicate-dialog';
export var DUPLICATE_DIALOG_LAZY_COMPONENT_NAME = 'duplicate-dialog-lazy-component';
export var MOVE_TO_TRASH_DIALOG_COMPONENT_NAME = 'move-to-trash-dialog';
export var MOVE_TO_TRASH_DIALOG_LAZY_COMPONENT_NAME = 'move-to-trash-dialog-lazy-component';
export var RESTORE_DIALOG_COMPONENT_NAME = 'restore-dialog';
export var RESTORE_DIALOG_LAZY_COMPONENT_NAME = 'restore-dialog-lazy-component';
export var REMOVE_FROM_TRASH_DIALOG_COMPONENT_NAME = 'remove-from-trash-dialog';
export var REMOVE_FROM_TRASH_DIALOG_LAZY_COMPONENT_NAME = 'remove-from-trash-dialog-lazy-component';
export var ADD_CONTRIBUTOR_DIALOG_COMPONENT_NAME = 'add-contributor-dialog';
export var ADD_CONTRIBUTOR_DIALOG_LAZY_COMPONENT_NAME = 'add-contributor-dialog-lazy-component';
export var CREATE_RENAME_FOLDER_DIALOG_COMPONENT_NAME = 'create-rename-folder-dialog-component';
export var CREATE_RENAME_FOLDER_DIALOG_LAZY_COMPONENT_NAME = 'create-rename-folder-dialog-lazy-component';
export var DELETE_FOLDER_DIALOG_COMPONENT_NAME = 'delete-folder-dialog';
export var DELETE_FOLDER_DIALOG_LAZY_COMPONENT_NAME = 'delete-folder-dialog-lazy-component';
export var MOVE_SITE_TO_FOLDER_DIALOG_COMPONENT_NAME = 'move-site-to-folder-dialog-component';
export var MOVE_SITE_TO_FOLDER_DIALOG_LAZY_COMPONENT_NAME = 'move-site-to-folder-dialog-lazy-component';
export var DialogBundleNames;
(function (DialogBundleNames) {
    DialogBundleNames["Transfer"] = "transfer-dialog-component";
    DialogBundleNames["Rename"] = "rename-dialog-component";
    DialogBundleNames["AddContributor"] = "add-contributor-dialog-component";
    DialogBundleNames["MoveToTrash"] = "move-to-trash-dialog-component";
    DialogBundleNames["Restore"] = "restore-dialog-component";
    DialogBundleNames["RemoveFromTrash"] = "remove-from-trash-dialog-component";
    DialogBundleNames["Duplicate"] = "duplicate-dialog-component";
    DialogBundleNames["MoveSiteToFolder"] = "move-site-to-folder-dialog-component";
    DialogBundleNames["Feedback"] = "feedback-dialog-component";
})(DialogBundleNames || (DialogBundleNames = {}));
//# sourceMappingURL=integration-config.js.map